import { useContext } from "react";
import { AppContext } from "../App";
import { MdCall, MdMenu, MdOutlineArrowOutward } from "react-icons/md";
import logoAtric from "../assets/A-logo.png";
import logoBcl from "../assets/B-logo.png";
import { IoMdCall } from "react-icons/io";

const NAV_ITEMS = [
  { key: "home", label: "Home" },
  { key: "about_us", label: "About Us" },
  { key: "services", label: "Services" },
  { key: "staff", label: "Staff" },
  { key: "news", label: "News & Events" },
  { key: "gallery", label: "Gallery" },
];

export default function TopBar() {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  return (
    <header className="TopBar">
      <div className="body">
        <div className="container h-100">
          <div className="topbar-shell h-100 d-flex align-items-center justify-content-between">
            <div className="topbar-brand-wrap d-flex align-items-center gap-2">
              <button
                type="button"
                className="topbar-menu-btn mMobileOnly"
                onClick={appContext.openSideBar}
                aria-label="Open menu"
              >
                <MdMenu size={22} />
              </button>

              <div className="topbar-brand" onClick={() => goTo("home")}>
                {appContext.navItem === "ATRIC-BCL"  ? <img src={logoBcl} className="bg-light p-1 rounded" height={50} /> : <img src={logoAtric} className="bg-light p-1 rounded" height={50} /> }
              </div>
            </div>

            <nav className="DesktopMenu topbar-nav" aria-label="Desktop navigation">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className="topbar-nav-link"
                  data-active={appContext.navItem === item.key}
                  onClick={() => goTo(item.key)}
                >
                  {item.label}
                </button>
              ))}
                <button
                  type="button"
                  className="btn text-light btn-sm p-2 bg-secondary"
                  onClick={() => goTo("contact_us")}
                >
                  <IoMdCall size={20} /> CONTACT US 
                </button>
            </nav>

            <div className="topbar-actions d-flex align-items-center">
              <button
                type="button"
                className="btn btn-outline-light btn-rounded mDesktopOnly"
                onClick={() => goTo("ATRIC-BCL")}
              >
                ATRIC BCL <MdOutlineArrowOutward size={16} />
              </button>

              <button
                type="button"
                className="topbar-call-btn mMobileOnly"
                onClick={() => goTo("contact_us")}
                aria-label="Contact us"
              >
                <MdCall size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
